import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import Icon from 'vue-awesome/components/Icon'
import App from '@/App.vue'
import router from '@/router'
import store from '@/store'
import Auth from "@aws-amplify/auth"
import Amplify, { API } from 'aws-amplify';
import aws_exports from '@/aws-exports'
import * as VueGoogleMaps from "vue2-google-maps"

Vue.use(VueGoogleMaps, {
  load: {
	key: "AIzaSyDurUL5lLSkkK44t868ugz6bXjZBPdQDck",
	libraries: "places"
  }
})



Vue.use(require('vue-moment'))

Auth.configure(aws_exports)
Amplify.configure(aws_exports)

Vue.use(BootstrapVue)
Vue.component('icon', Icon)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  el: '#app',
  render: h => h(App),
})
